import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { CardActivationConfirm } from './CardActivationConfirm';
import { CardActivationPlaced } from './CardActivationPlaced';

import { CardActivationStackParamList, CardActivationStackRoutes } from './type';

const CardActivationStack = createNativeStackNavigator<CardActivationStackParamList>();

export const CardActivationNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.CardActivation>> = ({
  route
}) => {
  const { account, tab, record, func, actionResponse, actionError, refresh } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [data, setData] = useState<any>(undefined);
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const onData = (value: any) => {
    setData(value);
  };

  return (
    <ModalContainerView dimensions={dimensions} nativeFlag={false}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <CardActivationStack.Navigator
          initialRouteName={CardActivationStackRoutes.Confirm}
          screenOptions={{
            presentation: 'transparentModal',
            headerShown: false,
            contentStyle: {
              backgroundColor: 'transparent'
            }
          }}>
          <CardActivationStack.Screen
            name={CardActivationStackRoutes.Confirm}
            component={CardActivationConfirm}
            initialParams={{ onLayout, account, tab, record, func, actionResponse, actionError, onData, refresh }}
            options={{ headerShown: false }}
          />
          <CardActivationStack.Screen
            name={CardActivationStackRoutes.Placed}
            component={CardActivationPlaced}
            initialParams={{ onLayout, account, tab, record, data, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </CardActivationStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
